import { render, staticRenderFns } from "./OperationDetail.vue?vue&type=template&id=c20600fa&scoped=true&"
import script from "./OperationDetail.vue?vue&type=script&lang=ts&"
export * from "./OperationDetail.vue?vue&type=script&lang=ts&"
import style0 from "./OperationDetail.vue?vue&type=style&index=0&id=c20600fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20600fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCardActions,VSkeletonLoader})
